import { render, staticRenderFns } from "./ActiveDataSharingConsents.vue?vue&type=template&id=f652afd6&"
import script from "./ActiveDataSharingConsents.vue?vue&type=script&lang=js&"
export * from "./ActiveDataSharingConsents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports